import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { Translation, provideTransloco, TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { TranslocoHttpLoader } from 'app/core/transloco/transloco.http-loader';

@NgModule({
    exports  : [
        TranslocoModule,
    ],
    providers: [
        provideTransloco({
            config: {
                availableLangs      : [
                    {
                        id   : 'en',
                        label: 'English',
                    },
                    {
                        id   : 'tr',
                        label: 'Turkish',
                    },
                ],
                defaultLang         : 'en',
                fallbackLang        : 'en',
                reRenderOnLangChange: true,
                prodMode            : true,
            },
            loader: TranslocoHttpLoader,
        }),
        provideAppInitializer(() => {
        const initializerFn = ((translocoService: TranslocoService): any => (): Promise<Translation> =>
            {
                const defaultLang = translocoService.getDefaultLang();
                translocoService.setActiveLang(defaultLang);
                return translocoService.load(defaultLang).toPromise();
            })(inject(TranslocoService));
        return initializerFn();
      }),
    ],
})
export class TranslocoCoreModule
{
}
